/* eslint-disable no-unused-vars */

import { useNavigate } from "react-router-dom";
import { api } from "../../api/api";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../context/GlobalContext";
import { consumeWaiterBlockedNotice, isWaiter, WAITER_APP_DOWNLOAD_URL, WAITER_WEB_BLOCKED_MESSAGE } from "../../utils/waiter";

import { CiMail, CiLock } from "react-icons/ci";
import { LuArrowRight } from "react-icons/lu";
import { FaAndroid } from "react-icons/fa";

import './style.css'

export function LoginPage() {
  const { setUser, setUserPermissions } = useContext(GlobalContext)

  const navigate = useNavigate();

  const [login, setLogin] = useState({
    email: '',
    password: ''
  })

  // garçom não entra na web: no lugar do formulário aparece o aviso com o download do app
  const [waiterBlocked, setWaiterBlocked] = useState(false)

  async function auth() {
    try {
      const res = await api.post('/users/auth', login)

      if (isWaiter(res.data.user)) {
        setWaiterBlocked(true)
        return
      }

      localStorage.setItem('access_token', res.data.token)
      localStorage.setItem('isModuleNota', res.data.isModuleNota)
      localStorage.setItem('isBotAtendimento', res.data.isBotAtendimento)
      localStorage.setItem('active', res.data.active)
      localStorage.setItem('message', res.data.message)
      localStorage.setItem('companyLink', res.data.companyLink)
      localStorage.removeItem('ja_mostro')
      localStorage.removeItem('modal-caixa')
      setUser(res.data.user)
      setUserPermissions(res.data.user.permissions)
      localStorage.setItem('user', JSON.stringify(res.data.user))
      navigate("/home");
    } catch (error) {
      // a mensagem de erro do login já é mostrada pelo interceptor da api
      console.error(error)
    }
  }

  function backToLogin() {
    setWaiterBlocked(false)
    setLogin({ email: '', password: '' })
  }

  useEffect(() => {
    // sessão de garçom descartada em src/index.js
    if (consumeWaiterBlockedNotice()) {
      setWaiterBlocked(true)
      return
    }

    if (localStorage.getItem('access_token')?.length > 0) {
      window.location.href = '/home'
    } else {
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
    }
  }, [])

  return (
    <div className="container-login">
      <div className="left-area">
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <div className="content-img-login">
            <img className="logo-login" src="./logo-sem-fundo.png" alt="Logo Unledu" />
          </div>

          <p style={{ margin: 0, fontWeight: 'bold', fontSize: '2rem', color: 'white' }}>Unledu</p>
        </div>

        <div>
          <p style={{ marginBottom: '1.5rem', fontWeight: 'bold', fontSize: '3.5rem', color: 'white', lineHeight: 1.2 }}>Gerencie seus pedidos de forma simples e eficiente</p>
          <p style={{ marginBottom: '1.5rem', width: '60%', fontSize: '1.3rem', lineHeight: 1.4, color: '#e9e9e9' }}>A plataforma completa para restaurantes que querem crescer e atender melhor seus clientes.</p>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '1rem', marginTop: '2rem' }}>
            <div style={{ borderRadius: '15px', backgroundColor: '#fd6b33', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.5rem 0.8rem' }}>
              <span style={{ marginRight: '0.3rem' }}>📊</span>

              <p style={{ margin: 0, fontWeight: '600', fontSize: '1rem', color: 'white' }}>Dashboard intuitivo</p>
            </div>

            <div style={{ borderRadius: '15px', backgroundColor: '#fd6b33', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.5rem 0.8rem' }}>
              <span style={{ marginRight: '0.3rem' }}>🍔</span>

              <p style={{ margin: 0, fontWeight: '600', fontSize: '1rem', color: 'white' }}> Gestão de cardápio</p>
            </div>

            <div style={{ borderRadius: '15px', backgroundColor: '#fd6b33', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.5rem 0.8rem' }}>
              <span style={{ marginRight: '0.3rem' }}>📱</span>

              <p style={{ margin: 0, fontWeight: '600', fontSize: '1rem', color: 'white' }}>App para clientes</p>
            </div>
          </div>
        </div>

        <div>
          <p style={{ margin: 0, fontSize: '1rem', lineHeight: 1, color: '#ffffff9c', fontWeight: 'bold' }}>© 2026 Unledu. Todos os direitos reservados.</p>
        </div>
      </div>

      <div className="right-area">
        <div style={{
          maxWidth: '400px',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
          <div style={{ marginBottom: '32px' }}>
            <p style={{ marginBottom: '0.7rem', fontWeight: 'bold', fontSize: 'var(--font-size-page-title)', color: 'black', lineHeight: 1.2 }}>Bem-vindo!</p>
            <p style={{ fontSize: 'var(--font-size-subtitle)', lineHeight: 1.4, color: '#616161' }}>Entre com suas credenciais para acessar sua conta.</p>
          </div>

          <div style={{
            zIndex: 10,
            width: '100%',
            padding: '24px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
            borderRadius: 15,
            boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
          }}>
            {/* <img src="./logo.png" width={230} alt="" /> */}
            {/* <h2>Acessar</h2> */}

            {waiterBlocked ? (
              <div role="alert" style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: '1rem' }}>
                <img src={`${process.env.PUBLIC_URL}/logo-garcom.png`} width={72} height={72} alt="App do Garçom Unledu" style={{ borderRadius: 16 }} />

                <h2 style={{ margin: 0, fontWeight: 'bold', fontSize: '1.1rem', color: 'black' }}>Use o app do garçom</h2>
                <p style={{ margin: 0, fontSize: 'var(--font-size-subtitle)', lineHeight: 1.4, color: '#616161' }}>{WAITER_WEB_BLOCKED_MESSAGE}</p>

                {WAITER_APP_DOWNLOAD_URL && (
                  <a href={WAITER_APP_DOWNLOAD_URL} target="_blank" rel="noreferrer" className="btn btn-lg w-100" style={{ height: '40px', borderRadius: '8px', fontWeight: '600', color: 'white', backgroundColor: '#1e7e44', lineHeight: 1.2, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
                    <FaAndroid size={20} aria-hidden="true" /> Baixar para Android
                  </a>
                )}

                <button type="button" className="btn btn-link p-0" style={{ fontSize: 'var(--font-size-subtitle)', fontWeight: 'bold' }} onClick={backToLogin}>Entrar com outra conta</button>
              </div>
            ) : (
              <form style={{ width: '100%' }}>
                <div className="mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label" style={{ fontSize: 12, fontWeight: 'bold', color: '#3b3b3b' }}>E-mail</label>

                  <div className="content-input">
                    <div style={{ width: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute' }}>
                      <CiMail size={20} />
                    </div>

                    <input type="email" placeholder="seu@email.com" onChange={(e) => setLogin(state => ({ ...state, email: e.target.value }))} value={login.email} className="form-control default-input-login" id="exampleInputEmail1" aria-describedby="emailHelp" />
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="exampleInputPassword1" className="form-label" style={{ fontSize: 12, fontWeight: 'bold', color: '#3b3b3b' }}>Senha</label>

                  <div className="content-input">
                    <div style={{ width: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute' }}>
                      <CiLock size={20} />
                    </div>

                    <input placeholder="••••••••" onChange={(e) => setLogin(state => ({ ...state, password: e.target.value }))} value={login.password} type="password" className="form-control default-input-login" id="exampleInputPassword1" />
                  </div>
                </div>


                <div style={{ margin: '1rem 0' }}>
                  <a onClick={() => navigate('/recover-password')} target="_blank" className='m-0 p-0' style={{ fontSize: 'var(--font-size-subtitle)', fontWeight: 'bold', cursor: 'pointer' }} rel="noreferrer">Esqueceu a senha?</a>
                </div>

                <button type="button" className="btn btn-lg btn-dark-blue w-100" style={{ height: '40px', borderRadius: '8px', fontWeight: '600', color: 'white', lineHeight: 1.2, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }} onClick={(e) => {
                  e.preventDefault()
                  auth()
                }}>Entrar <LuArrowRight style={{ marginLeft: '0.5rem' }} /></button>
              </form>
            )}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '5rem' }}>
            <div style={{ borderRadius: '15px', backgroundColor: '#fe85554b', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.7rem 0.8rem', marginTop: '2rem' }}>
              <p style={{ margin: 0, fontSize: '1rem', color: '#b04300', lineHeight: 1 }}>Versão de teste disponível</p>
            </div>

            <div style={{ cursor: 'pointer', borderBottom: 'solid 1px #ff6200' }} onClick={() => navigate('/register')}>
              <h3 style={{ color: '#d95300', fontSize: '1rem', margin: 0, }}>Clique aqui para testar gratuitamente</h3>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '1rem' }}>
            <p style={{ color: 'gray', fontSize: '1rem', margin: 0, }}>Termos de uso</p>
            <p style={{ color: 'gray', fontSize: '1rem', margin: 0, }}>•</p>
            <p style={{ color: 'gray', fontSize: '1rem', margin: 0, }}>Privacidade</p>
            <p style={{ color: 'gray', fontSize: '1rem', margin: 0, }}>•</p>
            <p style={{ color: 'gray', fontSize: '1rem', margin: 0, }}>Ajuda</p>
          </div>
        </div>
      </div>
    </div >
  )
}
